// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastForwardOutlinedSvg from "@fishx/icons-svg/es/asn/FastForwardOutlined";
import FishxIcon from '../components/FishxIcon';

var FastForwardOutlined = function FastForwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardOutlinedSvg
  }));
};

FastForwardOutlined.displayName = 'FastForwardOutlined';
export default React.forwardRef(FastForwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FastForwardOutlined.js
// module id = 2669
// module chunks = 0